import "@fontsource/ibm-plex-sans/300.css";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/inria-serif/300.css";
import "@fontsource/inria-serif/400.css";
import "@fontsource/inria-serif/700.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { GartherToaster } from "@garther/ui/libs";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import "./global.css";
import { initializeAnalytics } from "./libs/analytics";
import { SEO_ENABLED } from "./libs/configs";
import "./libs/i18n";
import { QueryClient } from "./libs/query-client";
import { routeTree } from "./routeTree.gen";
import { initializeAuthListeners } from "./stores/auth.store";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);

  // Initialize analytics
  initializeAnalytics();

  // Initialize auth listeners
  // const cleanupAuthListeners =
  await initializeAuthListeners();

  const AppContent = (
    <QueryClientProvider client={QueryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools initialIsOpen={false} />
      <GartherToaster />
    </QueryClientProvider>
  );

  root.render(
    <StrictMode>{SEO_ENABLED ? <HelmetProvider>{AppContent}</HelmetProvider> : AppContent}</StrictMode>
  );

  // Cleanup auth listeners when app unmounts
  // window.addEventListener("beforeunload", cleanupAuthListeners);
}
